import React from 'react'
import ArtifactStatusBadge from './ArtifactStatusBadge'

export default function UploadRow({ upload, onDismiss }) {
  const { fileName, progress, status, error } = upload
  const isDone = status === 'completed' || status === 'failed'

  const barColor =
    status === 'failed'
      ? 'bg-rose-500'
      : status === 'completed'
        ? 'bg-emerald-500'
        : 'bg-accent-500'

  return (
    <div className="rounded-lg border border-slate-200 bg-white p-4">
      <div className="flex items-center justify-between gap-3">
        <div className="min-w-0 flex-1">
          <div className="text-sm font-medium text-slate-900 truncate">{fileName}</div>
          {error && <div className="mt-1 text-xs text-rose-600">{error}</div>}
        </div>
        <div className="flex items-center gap-3">
          <ArtifactStatusBadge status={status === 'uploading' ? 'pending' : status} />
          {isDone && (
            <button
              type="button"
              onClick={() => onDismiss(upload.localId)}
              className="text-xs text-slate-400 hover:text-slate-600"
            >
              Dismiss
            </button>
          )}
        </div>
      </div>
      <div className="mt-3 h-1.5 w-full rounded-full bg-slate-100 overflow-hidden">
        <div
          className={`h-full transition-all duration-300 ${barColor}`}
          style={{ width: `${Math.max(progress, status === 'completed' ? 100 : status === 'uploading' ? progress : 10)}%` }}
        />
      </div>
    </div>
  )
}
